<template>  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vencimento de Certificados nos próximos 30 dias</h4>
          </div>
          <table class="table table-striped">
            <thead>
              <tr>
                <th>Cliente</th>
                <th>Razão Social</th> 
                <th>CNPJ</th> 
                <th class="text-right">Venc. do Certificado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="instalacao of instalacoes">
                <td>{{ instalacao.apelido }} ({{ instalacao.idi }})</td>
                <td>{{ instalacao.razao_social }}</td>
                <td>{{ instalacao.cnpj }}</td>
                <td class="text-right">{{ instalacao.valor}}</td>
                <td class="text-right">
                  <div v-if="instalacao.status_nota" class="status" v-bind:class="[instalacao.status_nota]"></div>
                  <div class="status" v-bind:class="[instalacao.status]"></div>
                </td>
              </tr>
              <tr v-if="!instalacoes || !instalacoes.length">
                <td class="text-center" colspan="6">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>
        </card>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
  } from 'src/components'
import moment from 'moment'
import InstalacaoService from '@/services/InstalacaoService.js'

export default {
    components: {
      Card,
      moment
    },
    data() {
      return {
        instalacoes: [],
      }
    },
    methods:{

      changePage(page) {
        this.current_page = page
        this.loadInstalacoes()
      },

      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadInstalacoes()
      },

      generate(idi) {
        let senha = prompt("Digite a senha")

        if(senha) {
          InstalacaoService.generate({ senha: senha, idi: idi}).then(res => {
            this.loadInstalacoes()
          })
          .catch(err => {
            console.error(err)
          })

        }
      },

      loadInstalacoes() {
        InstalacaoService.loadVencimento().then(res => {
          this.instalacoes = res.data
        }).catch(err => {
          console.error(err)
        })
      },
    },
    mounted() {
      this.loadInstalacoes()
    }
}
</script>

<style>
  .status {
    display: inline-block; margin-right: 6px;
  }
  .status.danger {
    background-color: red;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.alive {
    background-color: #26de81;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
  .status.warning {
    background-color: #fed330;
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }
</style>